import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { SkillResponse } from 'src/pages/Skills/types';
import QueryKeys from '../config';
import API from '../../../network';

const useSkills = (props?: { enabled?: boolean }) => {
  const { enabled } = props || { enabled: true };
  const {
    isLoading, data, error, refetch,
  } = useQuery({
    queryKey: QueryKeys.SKILLS,
    queryFn: async () => API.getInstance().fetchSkills().then((response) => response.data),
    refetchOnWindowFocus: false,
    initialData: [],
    enabled,
  });

  const skillsOptions = React.useMemo(
    () => data?.map(
      (option: SkillResponse) => ({ label: option?.value, value: option?.id.toString() }),
    ) || [],
    [data],
  );
  return {
    skillsLoading: isLoading,
    skillsOptions,
    data,
    error,
    fetchSkills: refetch,
  };
};

export default useSkills;
